import { MantineTheme, TitleOrder } from "@mantine/core";

/**
 * Modal `styles` that make a plain-text title look like `<Title order={order}>`. Mantine already
 * renders a modal's title in an <h2>, so passing a <Title> as the title nests one heading inside
 * another, which React reports as invalid markup (validateDOMNesting). TTV2-1920.
 */
export const modalTitleStyles = (order: TitleOrder) => (theme: MantineTheme) => {
    const heading = theme.headings.sizes[`h${order}`];

    return {
        title: {
            ...theme.fn.fontStyles(),
            fontFamily: theme.headings.fontFamily,
            fontSize: heading.fontSize,
            lineHeight: heading.lineHeight,
            fontWeight: heading.fontWeight ?? theme.headings.fontWeight,
        },
    };
};
